export const appName = 'akwedukt2'
export const appCaption = 'Akwedukt 2.0'
export const systemLogo = "logos/system_logo.webp";
export const menuLogo = "logos/menu_logo.webp";
export const developerLogo = "logos/developer_logo.webp";
export const startSplash = "logos/start_splash.webp";
export const underConstructionLogo = "logos/under_construction_logo.webp";
export const noPermissionLogo = "logos/no_permission_logo.webp";
export const bgTextureName = "textures/bg_texture_";
export const bgTextureExt = "webp";
export const warningIcon = "icons/warning_icon.png";
export const prematureIcon = "icons/premature_icon.png";

export const nbpUrl = 'https://api.nbp.pl/api/exchangerates/rates/A';
